import React, { Fragment } from "react";
import {
  Edit,
  EditProps,
  SimpleForm,
  TextInput,
  required,
  ImageInput,
  ImageField,
  TabbedForm,
  FormTab,
  ReferenceField,
  TextField,
  ReferenceInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  BooleanInput
} from "react-admin";
import { makeStyles } from "@material-ui/styles";
import Nutrition from "./Nutrition";
import { useTranslate } from "react-admin";
import RichTextInput from "ra-input-rich-text";
import PreviewImage from "./PreviewImage";
import UploadImages from "./UploadImages";
import { S3FileInput } from "@fusionworks/ra-s3-input";
import { apiUrl } from "../../utilities/type";

const useStyles = makeStyles((table) => ({
  root: {
    width: 800,
  },
  description: {
    width: 800,
    padding: 1,
  },
  nutrition: {
    width: 600,
  },
  tab: {
    maxWidth: "40em",
    display: "block",
  },
}));

const ProductsTitle = (props: any) => {
  const { record } = props;
  const translate = useTranslate();
  return record ? (
    <span>{translate("resources.products.name", { smart_count: 1 })}</span>
  ) : null;
};

const PreviewImages = ({ record, source }: any) => {
  let images: any[] = [];
  try {
    images = JSON.parse(record);
  } catch (err) {
    try {
      if (typeof record == "string") {
        record = {
          [source]: record,
        };
      }
      return <ImageField record={record} source={source} />;
    } catch (err) {
      console.log(err);
    }
  }
  if (!images) return null;
  return (
    <Fragment>
      {images.map((img, index) => {
        if (typeof img == "string") {
          img = {
            [source]: img,
          };
        }
        return <ImageField key={index} record={img} source={source} />;
      })}
    </Fragment>
  );
};

const ProductEdit = (props: EditProps) => {
  const classes = useStyles();
  return (
    <Fragment>
      <Edit title={<ProductsTitle />} {...props}>
        <SimpleForm>
          <TextInput source="name_en" validate={required()} label="Name (English)"/>
          <TextInput source="name_ar" validate={required()} label="Name (Arabic)"/>

          <TextInput source="barcode" validate={required()} label="Barcode"/>

          <ImageField source="featured_image" label="Featured Image" />
          <UploadImages sourceName="featured_image1" multiple={false} />
          <ImageField source="images" src="url" label="Image" />
          <UploadImages sourceName="images1" multiple={true} />

          <RichTextInput source="short_desc_en" label="Short Description (English)"/>
          <RichTextInput source="short_desc_ar" label="Short Description (Arabic)" />

          <RichTextInput source="long_desc_en" label="Long Description (English)" />
          <RichTextInput source="long_desc_ar" label="Long Description (English)" />

          <ReferenceInput source="category_id" reference="categories" label="Category">
                <SelectInput optionText="name_en" />
            </ReferenceInput>
          <ArrayInput source="nutrition" label="Nutrition">
                <SimpleFormIterator>
                    <TextInput source="label_en" helperText={false} label="Text (English)" />
                    <NumberInput source="value_en" helperText={false} label="Value (English)" />
                    <TextInput source="label_ar" helperText={false} label="Text (Arabic)" />
                    <NumberInput source="value_ar" helperText={false} label="Value (Arabic)" />
                    <TextInput source="style" helperText={false} label="Class" />
                </SimpleFormIterator>
            </ArrayInput>
          <TextInput source="price" label="Price" />
          <BooleanInput source="active" label="Active" />  
          {/* <UploadImages sourceName="featured_image" /> */}
        </SimpleForm>
        {/* 
          <TabbedForm>
            <FormTab
              label="Images"
              contentClassName={classes.tab}
            >
              
            </FormTab>
          </TabbedForm> */}
      </Edit>
    </Fragment>
  );
};

export default ProductEdit;
